module.exports = __webpack_public_path__ + "static/img/y22-2.27ccdc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y22-2.jpg
// module id = Nsnn
// module chunks = 1